import { Fragment, type ReactElement, type ReactNode } from 'react';
import { foldText } from './scopedList';

/**
 * Wrap every accent/case-insensitive hit of `query` in `<mark>`. The fold keeps one char
 * per char for NFC text, so offsets map back; when it does not (rare casing edge cases)
 * the text renders unmarked rather than mis-marked.
 */
export function Highlight({ text, query }: { text: string; query: string }): ReactElement {
  const q = foldText(query.trim());
  if (!q) return <>{text}</>;
  const folded = foldText(text);
  if (folded.length !== text.length) return <>{text}</>;
  const parts: ReactNode[] = [];
  let from = 0;
  let at = folded.indexOf(q);
  while (at >= 0) {
    if (at > from) parts.push(text.slice(from, at));
    parts.push(<mark key={at}>{text.slice(at, at + q.length)}</mark>);
    from = at + q.length;
    at = folded.indexOf(q, from);
  }
  if (from < text.length) parts.push(text.slice(from));
  return <Fragment>{parts}</Fragment>;
}
